<template>
    <div>
    <!-- <div class="hide_scroll" :style="{gridTemplateRows: teamList.length <= 3 ? `repeat(${teamList.length}, 1fr)` : 'repeat(3, 1fr)'}" style="display: grid; grid-auto-flow: column; gap: 18px; overflow-x: scroll; padding: 0 12px; padding-bottom: 2px;"> -->
        <div @click="showTeamDetail(each)" v-for="each, i in teamList" :key="i" style="border: 2px solid #8080801A; margin-bottom: 20px; position: relative; padding: 12px; box-shadow: 2px 2px 4px 0px #00000021; border-radius: 12px; border: 2px solid #8080801A">
            <div style="display: flex; align-items: center; justify-content: space-between; gap: 12px">
                <div style="display: flex; gap: 12px; align-items: center; flex: 1;">
                    <div style="">
                        <img style="width: 50px; height: 50px; object-fit: cover;" :src="$resourcePath + each.image_path" alt="">
                    </div>
                    <div style="padding-right: 22px;">
                        <div class="ellipsis" style="font-weight: 700; line-height: 21px;">{{ each.name }}</div>
                        <div style="display: flex; align-items: center; gap: 10px; margin-top: 8px;">
                            <div style="display: flex; align-items: center; gap: 4px;">
                                <img style="width: 10px;" :src="require('@/assets/img/loc_gray.png')" alt="">
                                <div style="font-size: 12px; color: #808080; font-weight: 500;">{{ each.place.name }}</div>
                            </div>
                            <div style="width: 1px; height: 10px; margin-top: 2px; background-color: #808080;"></div>
                            <div style="display: flex; align-items: center; gap: 4px;">
                                <img style="width: 10px;" :src="require('@/assets/img/coach_gray.png')" alt="">
                                <div style="font-size: 12px; color: #808080; font-weight: 500;">{{ each.manager.name }} 감독</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="position: absolute; right: 24px;">
                    <img style="width: 7px;" :src="require('@/assets/img/arrow_gray_new.png')" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'JoinSoccerTeamWrapper',
    props: {
        teamList: {
            type: Array,
            default: () => { }
        }
    },
    methods: {
        showTeamDetail(teamDetail) {
            this.$GlobalStore.addModal('SoccerTeamDetail', { isModalBackTransparent: true, teamIdx: teamDetail.idx })
        },
        transAge(age) {
            if (age === 'U12') {
                return '초등학교'
            } else if (age === 'U15') {
                return '중학교'
            } else if (age === 'U18') {
                return '고등학교'
            } else if (age === '대학팀') {
                return '대학교'
            } else {
                return ''
            }
        }
    }
}
</script>

<style scoped>
.ellipsis {
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical
}
</style>